import { Box } from 'components/Box';
import { Button } from 'components/Button/Button';
import { Icon } from 'components/Icon/Icon';
import { Image } from 'components/Image/Image';
import { CopyClipboardButton, ShareButton } from 'components/SocialButton';
import { BodySmall } from 'components/Text/BodySmall';
import { H3 } from 'components/Text/H3';
import { RichText } from 'components/Text/RichText';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsApiPersonaResult } from 'modules/cms/api/types/blocks/CmsApiPersonaQuizBlock';
import { colors } from 'theme/theme';
import { imageUrl } from 'utils/filestack';

const socialEvent = 'Share Persona Quiz Results';

type Props = {
  blockIndex?: number;
  result: CmsApiPersonaResult;
  content?: CmsApiPage;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clickRetake?: (...args: Array<any>) => any;
};

export function CmsPersonaQuizBlockResult({
  blockIndex,
  result: { title, description, image, socialMediaText },
  content,
  clickRetake,
}: Props) {
  const message = socialMediaText;
  return (
    <Box
      borderRadius={32}
      data-qa-id="cms-persona-quiz-results"
      overflow="hidden"
      bg={colors.inputGrey}
    >
      <Box
        px={32}
        py={16}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        backgroundImage={`linear-gradient(
        to left,
        ${colors.skyBlue},
        ${colors.hoverBlue}
      )`}
        color="white"
      >
        <BodySmall>{getText('Results')}</BodySmall>

        <Box display="flex" alignItems="center">
          <Button onClick={clickRetake}>
            <Icon name="refresh" size={16} />
          </Button>
          <BodySmall>{getText('Retake')}</BodySmall>
        </Box>
      </Box>

      <Box p={32}>
        <Box p={[12, null, 32]} borderRadius={16} bg="white">
          {image && (
            <Box
              data-qa-id="result-image"
              marginLeft={32}
              marginBottom={32}
              width="50%"
              style={{ float: 'right' }}
            >
              <Image
                src={imageUrl({
                  data: image,
                  width: undefined,
                  height: undefined,
                  fit: 'max',
                  insecureSVG: false,
                })}
                alt={title || image.altText || ''}
              />
            </Box>
          )}
          <H3 data-qa-id="result-title">{title}</H3>
          <RichText
            analyticsData={
              blockIndex
                ? {
                    eventName: 'CMS Block',
                    eventProperties: {
                      block_position: blockIndex,
                      block_type: 'Persona Quiz',
                    },
                  }
                : {}
            }
            data-qa-id="result-description"
            // @ts-expect-error TODO fix me
            html={description}
          />

          {content && (
            <Box
              mt={32}
              mx="-4px"
              display="flex"
              flexWrap="wrap"
              gridGap="8px"
              my="4px"
            >
              <ShareButton
                object={content}
                objectType="CMS_PAGE"
                socialType="facebook"
                utmParams={{}}
                message={message}
                eventName={socialEvent}
                eventProperties={{
                  type: 'Facebook',
                }}
              />

              <ShareButton
                object={content}
                objectType="CMS_PAGE"
                socialType="twitter"
                utmParams={{}}
                message={message}
                eventName={socialEvent}
                eventProperties={{
                  type: 'Twitter',
                }}
              />

              <ShareButton
                object={content}
                objectType="CMS_PAGE"
                socialType="linkedin"
                utmParams={{}}
                message={message}
                eventName={socialEvent}
                eventProperties={{
                  type: 'LinkedIn',
                }}
              />

              <CopyClipboardButton
                object={content}
                objectType="CMS_PAGE"
                data-qa-id="persona-quiz-copy-link"
                utmParams={{}}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
